export default __webpack_public_path__ + "static/media/gallery_19.2cba236c.jpg";